import React, { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

function RefineCodeEditor({ refinedCode, setValue, setShowPopup, setLoadingCard, language }) {
    // Extract code blocks from refinedCode
    const extractCodeBlocks = (markdown) => {
        const codeBlockRegex = /```[\s\S]*?```/g; // Regex to match code blocks
        const matches = markdown.match(codeBlockRegex);
        if (!matches) return null;

        // Remove the triple backticks and language specifier
        return matches.map((block) => block.replace(/```[\w\s]*\n/, '').replace(/```$/, ''));
    };

    const handleApply = useCallback(() => {
        const codeBlocks = extractCodeBlocks(refinedCode);
        if (codeBlocks && codeBlocks.length > 0) {
            setValue(codeBlocks[0]);
        } else {
            setValue(refinedCode);
        }

        setShowPopup(false);
        setLoadingCard(false);
    }, [refinedCode, setValue, setShowPopup, setLoadingCard]);

    return (
        <div className="absolute top-20 left-[10%] w-10/12 bg-white shadow-lg rounded-lg p-4 z-50 transition-all duration-500 transform ease-in-out">
            <h3 className="font-bold mb-2">Refined Code</h3>
            <div className="bg-gray-100 p-2 rounded-md text-sm h-40 whitespace-pre-wrap break-words overflow-auto">
            <ReactMarkdown
                children={refinedCode}
                components={{
                    code({ node, inline, className, children, ...props }) {
                        const match = /language-(\w+)/.exec(className || '');
                        return !inline && match ? (
                            <SyntaxHighlighter
                                style={dracula}
                                language={match[1] || language}
                                PreTag="pre"
                                {...props}
                            >
                                {String(children).replace(/\n$/, '')}
                            </SyntaxHighlighter>
                        ) : (
                            <code {...props} style={{ backgroundColor: '#f3f4f6', padding: '0.2rem', borderRadius: '0.25rem' }}>
                                {children}
                            </code>
                        );
                    },
                    p({ node, children, ...props }) {
                        return (
                            <div {...props} style={{ marginBottom: '0.5rem', color: '#1f2937' }}>
                                {children}
                            </div>
                        );
                    },
                }}
            />

            </div>
            <div className="flex justify-end mt-2">
                <button
                    className="mr-2 bg-blue-500 text-white px-4 py-1 rounded"
                    onClick={handleApply}
                >
                    Apply
                </button>
                <button
                    className="bg-gray-400 text-white px-4 py-1 rounded"
                    onClick={() => setShowPopup(false)}
                >
                    Dismiss
                </button>
            </div>
        </div>
    );
}

export default RefineCodeEditor;
